<template lang="html">
  <v-sheet class="w-100 h-100 d-flex justify-center align-center" color="transparent">
	<div class="w-100 d-flex justify-content-start" v-if="value">
		<v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span class="w-100" v-bind="attrs" v-on="on">
          <v-icon color="primary">mdi-calendar-check</v-icon>
          <span class="font-weight-bold primary--text pl-1">{{ value }}</span>
        </span>
      </template>
      <v-list color="transparent" dense>
        <v-list-item v-for="(task, index) in tasks" :key="index" dense>
          <v-list-item-content>
            <v-list-item-title dense class="white--text">
							<v-chip v-if="task.status" width="150" class="mr-2 white--text" x-small :color="task.status?.color">{{ task.status?.name }}</v-chip>
							<span>{{ task.name }}</span>
						</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-tooltip>
	</div>
	<div class="w-100 d-flex justify-content-start" v-else>
    <span class="w-100">
      <v-icon>mdi-calendar-remove</v-icon>
    </span>
	</div>
  </v-sheet>
</template>
<script>
  export default {
    name: 'TasksCountRenderer',
    computed: {
      value() {
        return this.params.value;
      },
			tasks() {
				return this.params.data?.relatedTasks ?? [];
			},
    },
  };
</script>
<style lang="scss">
  .tasks-count-chip {
    .v-chip__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }
</style>
